import { DataLayer } from "@sazka/utils/data-layer";
import { TicketsSortingOption } from "@/tickets/utils/tickets-sorting-option-enum";

export namespace OnlineTicketsCategoryPageAnalytics {
    // V1.0

    // DL1.10
    export function pushLosyLobbyPage() {
        DataLayer.push({
            page: {
                type: "lobby.escratches",
                kind: "lobby.escratches",
                verticalCode: "losy",
                verticalCodeStrict: "losy",
                gameCode: "no_game",
                gameCodeStrict: "no_game",
            },
        });
    }

    // DL1.20
    export enum OnlineTicketsPlacement {
        AllScratches = "allScratches",
        FavoriteScratches = "favoriteScratches",
        NewScratches = "newScratches",
        MostPlayed = "mostPlayed",
        FamilyScratches = "familyScratches",
        Homepage = "homepage",
    }

    interface Product {
        id: string;
        gameCode: string;
        verticalCode: string;
        placement: OnlineTicketsPlacement;
        position: string;
    }

    interface DataLayerPayload {
        event: string;
        action: {
            show: {
                products: Product[];
                eventProperty1?: string;
                eventProperty2?: string;
            };
        };
    }

    export function pushTicketClick(
        gameCode: string,
        placement: OnlineTicketsPlacement,
        position: string,
        filterValues?: string,
        selectedSorting?: string
    ) {
        const product: Product = {
            id: gameCode,
            gameCode: gameCode,
            verticalCode: "elosy",
            placement: placement,
            position: position,
        };

        const dataLayerPayload: DataLayerPayload = {
            event: "action.show.products",
            action: {
                show: {
                    products: [product],
                },
            },
        };

        if (placement === OnlineTicketsPlacement.AllScratches) {
            dataLayerPayload.action.show.eventProperty1 = filterValues;
            dataLayerPayload.action.show.eventProperty2 = selectedSorting;
        }

        DataLayer.pushInstant(dataLayerPayload);
    }

    // DL1.30
    export function pushRandomBetEvent() {
        DataLayer.push({
            event: "action.click.randombet",
        });
    }

    // DL1.31
    export function pushShowProductEvent(gameCode: string, buttonText: string) {
        DataLayer.pushInstant({
            event: "action.show.products",
            action: {
                show: {
                    products: [
                        {
                            id: gameCode,
                            gameCode: gameCode,
                            verticalCode: "elosy",
                            placement: "randomBet",
                            button: buttonText,
                        },
                    ],
                },
            },
        });
    }

    // DL1.32
    export function pushRandomBetEventAgain() {
        DataLayer.push({
            event: "action.clickNext.randombet",
        });
    }

    // DL1.70 implemented in analytics-secondary-nav.ts (it's shared between lotteries and tickets)

    // DL1.80
    export function pushLobbyFilterGameList(filteredValues: string) {
        DataLayer.push({
            event: "action.applyFilter.escratches",
            action: {
                applyFilter: {
                    label: filteredValues,
                },
            },
        });
    }

    // DL1.90
    export function pushLobbySortGameList(sortingType: TicketsSortingOption) {
        DataLayer.push({
            event: "action.sort.escratches",
            action: {
                sort: {
                    label: sortingType,
                },
            },
        });
    }

    // DL4.10, DL4.20, DL4.30 and DL4.40 implemented in app/shared/utils/analytics/analytics-cp-widget-banner.ts

    // DL4.25
    export function pushActionImpressProducts(
        gameCode: string,
        placement: "mostPlayed" | "favoriteScratches",
        position: number
    ) {
        DataLayer.push({
            event: "action.impress.products",
            action: {
                impress: {
                    products: [
                        {
                            id: gameCode,
                            gameCode: gameCode,
                            verticalCode: "elosy",
                            placement: placement,
                            position: position,
                        },
                    ],
                },
            },
        });
    }

    // DL4.25 (second part)
    export function pushActionImpressProductsTicketFamily(gameCode: string, index: number, position: number) {
        DataLayer.push({
            event: "action.impress.products",
            action: {
                impress: {
                    products: [
                        {
                            id: gameCode,
                            gameCode: gameCode,
                            verticalCode: "elosy",
                            placement: "familyScratches",
                            position: `escratches.${index}.${position}`,
                        },
                    ],
                },
            },
        });
    }
}
